module.exports = __webpack_public_path__ + "static/img/edge.01e5589.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/edge.jpg
// module id = EYN+
// module chunks = 0